import { AddressResponseV1 } from '@core/models/address';
import { EstablishmentAddressV1 } from '@core/models/establishment';
import { OrderAddress } from '@core/models/order';

export interface FormattableAddress {
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  zip: string;
}

export function formatAddress(address: FormattableAddress): string {
  const parts = [address.line1];
  if (address.line2) {
    parts.push(address.line2);
  }
  parts.push(`${address.city}, ${address.state} ${address.zip}`);
  return parts.join(', ');
}

export function addressToDeliveryAddress(address: AddressResponseV1): OrderAddress {
  return {
    streetAddress: address.street,
    streetAddress2: address.street2,
    city: address.city,
    state: address.state,
    country: 'US',
    zipCode: address.zipCode,
    latitude: address.geometry.coordinates[1],
    longitude: address.geometry.coordinates[0]
  };
}

export function establishmentAddressToDeliveryAddress(address: EstablishmentAddressV1): OrderAddress {
  return {
    streetAddress: address.addressLineOne,
    streetAddress2: address.addressLineTwo,
    city: address.city,
    state: address.state,
    country: 'US',
    zipCode: address.zip,
    latitude: address.latitude,
    longitude: address.longitude
  };
}
